<template>
  <LoginWrapper>
    <template v-slot:main>
      <div v-if="!requestSent">
        <h2 class="login-title">Enter the email address of your login</h2>
        <div>We&apos;ll send you a link to reset your password</div>
        <FormGroup v-bind:form="entryForm">
          <div class="row input-row mt-4 mb-2">
            <div class="col-12">
              <FormInputText
                placeholder="Email"
                v-model="email"
                field="email"
                class="login-input"
                icon="fa-envelope"
              />
            </div>
          </div>
          <div class="row input-row my-4">
            <div class="col-12">
              <FormButton
                type="submit"
                :loading="submitting" 
                @click="onSendLink"
                class="btn-lg block full-width login-submit">SEND LINK</FormButton>
            </div>
          </div>
          <div class="row input-row">
            <div class="col-12 text-left login-recaptcha-notice">
              This site is protected by reCAPTCHA and the Google
              <a href="https://policies.google.com/privacy" target="_blank">Privacy Policy</a> and
              <a href="https://policies.google.com/terms" target="_blank">Terms of Service</a> apply.
            </div>
          </div>
          <div class="row input-row mt-2">
            <div class="col-12 text-left">
              <router-link to="/login">Back to sign in</router-link>
            </div>
          </div>
        </FormGroup>
      </div>
      <div v-if="requestSent">
        <h2 class="login-title">Request for reset password has been emailed</h2>
        <div>Check your inbox shortly for the link to complete resetting your password</div>
      </div>
    </template>
    <template v-slot:sidebar>
      <div class="login-side-title">Welcome</div>
        Already have an account?<br />
        <div class="mt-2">
          <router-link to="/login" class="login-sidebar-button">Sign In</router-link>
        </div>
    </template>
  </LoginWrapper>
</template>


<script>
import form from '@/mixins/form'
import LoginWrapper from '@/modules/core/components/loginWrapper'

export default {
  name: 'AccountForgotPassword',
  mixins: [form],
  components: {
    LoginWrapper,
  },
  data: () => {
    return {
      email: '',
      entryForm: {},
      requestSent: false,
      submitting: false
    };
  },
  methods: {
    async onSendLink() {
      this.$data.entryForm = this.clearFormResponse()
      this.submitting = true

      try {
        // Ensure ReCaptcha is loaded & get the token
        await this.$recaptchaLoaded()
        let recaptchaToken = await this.$recaptcha('forgotpassword')

        this.$api.post('/users/forgotpassword', {
            email: this.email,
            recaptchaToken: recaptchaToken
          })
          .then(response => {
            this.requestSent = true
          })
          .catch(err => {
            // Process errors
            this.$data.entryForm = this.processFormResponse(err);
          })
          .finally(() => {
            this.submitting = false
          })
      } catch(err) {
        this.$data.entryForm = this.processFormResponse('Error while processing request. If this continues, please check your internet connection or contact Synergy Software')
        this.submitting = false
      }
    }
  }
}
</script>